<div class="red-page">

    <!-- Hero -->
    <div class="red-hero">
        <div class="container">
            <div class="red-hero__layout">
                <div class="red-hero__content">
                    <h1>Red de Investigadores <span>INFANTIA</span></h1>
                    <p>Una red interdisciplinaria orientada al estudio de la infancia y la juventud, con énfasis en investigación aplicada, innovación social e incidencia en política pública en la región Caribe.</p>
                    <p>La Red INFANTIA se encuentra en una etapa inicial de estructuración. En este momento estamos realizando el <strong>mapeo de actores</strong> interesados en sumarse a esta iniciativa.</p>
                    <p>Si trabajas en temas relacionados con la infancia, la adolescencia o la juventud desde cualquier sector, te invitamos a ser parte de este espacio colaborativo.</p>
                </div>
            </div>
        </div>
    </div>

    <div class="container red-body">

        <!-- Quiénes somos + Misión + Visión -->
        <div class="red-section">
            <div class="red-section__heading">
                <h2>¿Quiénes somos?</h2>
                <p class="red-section__intro">La Red de Investigadores INFANTIA es una iniciativa liderada por el CIDHUM – Universidad del Norte, que articula actores interesados en el estudio de la infancia y la juventud desde una perspectiva interdisciplinaria, con énfasis en investigación aplicada, innovación social e incidencia en política pública en la región Caribe.</p>
            </div>

            <div class="red-mv-grid">
                <div class="red-mv-card red-mv-card--mision">
                    <div class="red-mv-card__heading">
                        <div class="red-mv-card__icon"><i class="fas fa-bullseye"></i></div>
                        <h3>Misión</h3>
                    </div>
                    <p>Articular actores públicos y privados para impulsar investigación aplicada e innovación social que fortalezca el desarrollo integral de la infancia y juventud mediante evidencia y trabajo interinstitucional.</p>
                </div>
                <div class="red-mv-card red-mv-card--vision">
                    <div class="red-mv-card__heading">
                        <div class="red-mv-card__icon"><i class="fas fa-binoculars"></i></div>
                        <h3>Visión</h3>
                    </div>
                    <p>Ser una red referente en la región Caribe y a nivel nacional por su capacidad de generar evidencia, proyectos colaborativos e incidir en políticas públicas para mejorar el bienestar infantil y juvenil.</p>
                </div>
            </div>
        </div>

        <!-- Qué hacemos -->
        <div class="red-section">
            <h2>¿Qué hacemos?</h2>
            <div class="red-activities">
                <div class="red-activity-card">
                    <div class="red-activity-card__heading">
                        <div class="red-activity-card__icon"><i class="fas fa-users"></i></div>
                        <h3>Mesas temáticas de trabajo</h3>
                    </div>
                    <p>Espacios de encuentro interdisciplinario para analizar problemáticas y construir propuestas colectivas en torno a la infancia y la adolescencia.</p>
                </div>
                <div class="red-activity-card">
                    <div class="red-activity-card__heading">
                        <div class="red-activity-card__icon"><i class="fas fa-file-alt"></i></div>
                        <h3>Formulación de propuestas</h3>
                    </div>
                    <p>Articulación de esfuerzos para la presentación conjunta de proyectos a convocatorias nacionales e internacionales de investigación e innovación.</p>
                </div>
                <div class="red-activity-card">
                    <div class="red-activity-card__heading">
                        <div class="red-activity-card__icon"><i class="fas fa-graduation-cap"></i></div>
                        <h3>Formación y mentoría</h3>
                    </div>
                    <p>Acompañamiento y mentoría a jóvenes investigadores y estudiantes de posgrado que inician su trayectoria en la investigación sobre infancia y juventud.</p>
                </div>
            </div>
        </div>

        <!-- Cómo vincularse -->
        <div class="red-section">
            <div class="red-section__heading">
                <h2>¿Cómo vincularse a la Red INFANTIA?</h2>
                <p class="red-section__intro">La Red de Investigadores INFANTIA es un espacio abierto y colaborativo, orientado a la articulación de conocimiento, experiencias y acciones en favor de la infancia y la adolescencia.</p>
                <p class="red-section__intro">Pueden vincularse personas e instituciones que trabajen en temas relacionados con la infancia y la adolescencia, desde distintos roles y sectores:</p>
            </div>

            <div class="red-actors-grid">
                <div class="red-actor"><i class="fas fa-microscope"></i><span>Investigadores e investigadoras</span></div>
                <div class="red-actor"><i class="fas fa-user-graduate"></i><span>Jóvenes investigadores y estudiantes de posgrado</span></div>
                <div class="red-actor"><i class="fas fa-chalkboard-teacher"></i><span>Docentes y formadores</span></div>
                <div class="red-actor"><i class="fas fa-heartbeat"></i><span>Profesionales del sector salud, educación y desarrollo social</span></div>
                <div class="red-actor"><i class="fas fa-hands-helping"></i><span>Organizaciones sociales, fundaciones y ONG</span></div>
                <div class="red-actor red-actor-landmark"><i class="fas fa-landmark"></i><span>Funcionarios públicos vinculados a programas de infancia y adolescencia</span></div>
                <div class="red-actor"><i class="fas fa-briefcase"></i><span>Actores del sector privado con iniciativas orientadas al bienestar infantil</span></div>
            </div>

            <div class="red-direct-contacts">
                <h2>Contactos directos</h2>
                <ul>
                    <li>
                        <i class="fas fa-user" aria-hidden="true"></i>
                        <div class="red-contact">
                            <strong>Red INFANTIA</strong>
                            <a href="mailto:redinfantia@gmail.com">redinfantia&#64;gmail.com</a>
                        </div>
                    </li>
                    <li>
                        <i class="fas fa-user" aria-hidden="true"></i>
                        <div class="red-contact">
                            <strong>José Juan Amar Amar</strong>
                            <a href="mailto:jamar@uninorte.edu.co">jamar&#64;uninorte.edu.co</a>
                        </div>
                    </li>
                    <li>
                        <i class="fas fa-user" aria-hidden="true"></i>
                        <div class="red-contact">
                            <strong>Jorge Enrique Palacio Sañudo</strong>
                            <a href="mailto:jpalacio@uninorte.edu.co">jpalacio&#64;uninorte.edu.co</a>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="red-cta">
                <p>¿Listo para unirte? Completa el formulario de inscripción y nos ponemos en contacto contigo.</p>
                <div class="cta-buttons">
                    <a href="https://forms.gle/gF3rYtz1K5kLJyLn8" target="_blank" rel="noopener noreferrer" class="btn-join btn-join--large">
                        <i class="fas fa-user-plus"></i> Únete a la Red
                    </a>
                    <a href="mailto:redinfantia@gmail.com" class="btn-contact">
                        <i class="fas fa-envelope"></i> Contáctanos
                    </a>
                </div>
            </div>
        </div>

    </div>
</div>
